import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as UnlockIcon } from './unlock.svg';

export const Unlock = IconHOC(UnlockIcon);
